import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DatesService } from '../../services/dates/dates.service';
import { environment } from '../../../../environments/environment';
import { UserSelectionsService } from '../../services/user-selections/user-selections.service';
import { TimeBoard } from '../../types/date-and-times';
import { Calendar, SelectAppointment } from '../../types/strings.type';
import { StringsService } from '../../services/strings/strings.service';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CalendarDay, MonthStartSignifier } from '../../types/date-and-times';
import { takeWhile } from 'rxjs/operators';
import { ErrorService } from '../../services/errors/error.service';
import { Utilities } from '../../utilities/utilities';
import { Product } from '../../types/product.type';
import { Router } from '@angular/router';
import { AppInsightsMonitoringService } from '../../services/logging/appInsightsMonitoring.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';


@Component({
    selector: 'rttd-calendar',
    templateUrl: './calendar.component.html',
    styles: [
        require('./calendar.component.scss').default.toString(),
        require(`./calendar.component.${environment.brand}.scss`).default.toString()
    ],
    preserveWhitespaces: true,
    animations: [
        trigger('openClose', [
            state('open', style({
                height: '*'
            })),
            state('closed', style({
                height: '56px'
            })),
            transition('open => closed', [
                animate(500)
            ]),
            transition('closed => open', [
                animate(500)
            ])
        ])
    ]
})
export class CalendarComponent implements OnInit, OnChanges {
    @Input() isOffsite: boolean;
    @Input() showPrefernces: boolean = true;
    @Output() dayCount = new EventEmitter();

    dates: (CalendarDay | MonthStartSignifier)[] = [];
    selectedTime: TimeBoard;
    selectedDay: CalendarDay = null;
    content: Calendar;
    selectAppointmentContent: SelectAppointment;
    calendarCollapsed = true;
    modelPreferencesPrefil: string;
    loaded = false;
    timezone = environment.timezone;
    firstDay: CalendarDay;
    noAvailability = false;
    isPreselectCompleted = false;
    isEvent = this.appSettings.eventJourney;

    constructor(
        private datesService: DatesService,
        public userSelectionsService: UserSelectionsService,
        private stringsService: StringsService,
        public appSettings: AppSettings,
        private errorService: ErrorService,
        private utilities: Utilities,
        private router: Router,
        private appInsightsService: AppInsightsMonitoringService,
        private analytics: AnalyticsService
    ) {
    }


    getJourneyProperties() {
        var properties = {
            combinedModelName: null,
            modelTreeRef: null,
            start: null,
            startTime: null,
            url: null
        };

        if (this.userSelectionsService.selections.product != null) {
            properties.combinedModelName = this.userSelectionsService.selections.product.combinedModelName;
            properties.modelTreeRef = this.userSelectionsService.selections.product.modelTreeRef;
        }

        if (this.userSelectionsService.selections.startDate != null) {

            properties.start = this.userSelectionsService.selections.startDate;
            properties.startTime = this.userSelectionsService.selections.startTime;
        }
        if (this.router.routerState != null) {
            properties.url = this.router.routerState.snapshot.url;
        }
        return properties;
    }

    ngOnInit() {

        this.userSelectionsService.currentProductSelections$.subscribe((product: Product) => {
            //if we have no product, we dont know which model we should be displaying dates for so redirect to model selection
            if (product == null) {
                this.appInsightsService.logEvent('calendar-no-product', this.getJourneyProperties());
                this.router.navigate(['select-model'], { skipLocationChange: true });
            }

            //if we have a product id, we can get availability!
            if (product.id != null || product.modelTreeRef) {
                /**
             * Get calendar dates.
             */
                this.applyDates(this.isOffsite);

                this.stringsService.get().subscribe((data: SelectAppointment) => {
                    this.selectAppointmentContent = data['SelectAppointment'];
                });
                this.stringsService.get().subscribe((data: Calendar) => {
                    this.content = data['Calendar'];
                });
                this.modelPreferencesPrefil = this.userSelectionsService.get('modelPreferences');
                if (!this.modelPreferencesPrefil) {
                    this.userSelectionsService.set('modelPreferences', '');
                }
            }
            else {
                 //if we have a modeltreeref, no id and the product isnt active, we need to redirect to the old form
                if (product.modelTreeRef != null && product.enabled == false) {
                    this.appInsightsService.logEvent('calendar-no-product-id', this.getJourneyProperties());
                    window.location.href = this.buildOldFormUrl(product);
                }
            }



        });


    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes.isOffsite.isFirstChange()) {
            this.loaded = false;
            this.dates = [];
            this.isPreselectCompleted = false;
            this.applyDates(changes.isOffsite.currentValue);
        }
    }

    /**
     * @description Gets data from getAvailableDates(), then applies the data to the calendar methods
     */
    applyDates(isOffsite) {
        this.datesService.getAvailableDates(isOffsite).subscribe((calendarDays: CalendarDay[]) => {

            var daysWithSingleAvailableTime = calendarDays.filter(element => element.availableTimesCount == 1)
            var daysWithMultipleAvailableTime = calendarDays.filter(element => element.availableTimesCount > 1)

            this.dates = calendarDays;
            this.firstAvailableInFirstRow();
            this.firstDay = this.onlyCalendarDates()[0];
            this.injectMonthStartLabel();
            this.loaded = true;
            const buttonTest = this.dates.filter((date: CalendarDay) => {
                return date.availableTimesCount !== 0;
            });

            if (daysWithSingleAvailableTime.length == 1 && daysWithMultipleAvailableTime.length == 0) {
                var time =
                    this.timeSelected(daysWithSingleAvailableTime[0].times.find(element => element.isAvailable == true), true);

                this.dayCount.emit({ days: 1, singleTime: true });
            }
            else {

                this.preselectDateTime();

                this.dayCount.emit({ days: buttonTest.length, singleTime: false });

            }

        });
    }
    /**
     * Check to see if the first available day is not in the 1st row.
     *
     * If it's not, then open the calendar.
     */
    firstAvailableInFirstRow() {
        const firstAvailableDate = this.dates.findIndex(date => {
            if (date.hasOwnProperty('availableTimesCount')) {
                if (date['availableTimesCount'] > 0) {
                    return true;
                }
            }
        });
        if (window.innerWidth >= this.utilities.deviceSizes('medium')) {
            if (firstAvailableDate >= 7) {
                this.calendarCollapsed = false;
            }
        }
        if (window.innerWidth < this.utilities.deviceSizes('medium')) {
            if (firstAvailableDate >= 4) {
                this.calendarCollapsed = false;
            }
        }
    }

    /**
     * @description Find the start of months in this.dates and injects
     * a MonthStartSignifier before.
     */
    injectMonthStartLabel() {
        this.onlyCalendarDates().forEach((dateItem: CalendarDay, index: number) => {
            if (dateItem.date.getDate() === 1 &&
                this.onlyCalendarDates()[index - 1] &&
                this.onlyCalendarDates()[index - 1].date.getDate() > 1
            ) {
                this.dates.splice(index, 0, {
                    month: dateItem.date
                });
            }
        });
    }

    /**
     * @description Attempts to fetch a date from the userSelectionService. If successful, it
     * sets the active states and opens the calendar. If unsuccessful, it calls this.preselectFirstDay().
     */
    preselectDateTime() {

        this.userSelectionsService.currentSelections$.pipe(
            takeWhile(() => !this.isPreselectCompleted)
        ).subscribe((selection: any) => {


            if (selection && selection.startTime) {

                const selectionMatchedDate = this.onlyCalendarDates().find(day =>
                    day.date.getMonth() === selection.startTime.getMonth()
                    && day.date.getDate() === selection.startTime.getDate()
                    && day.availableTimesCount > 0);

                // If there's no availability on the selected date, forget it and select the first
                // date and time where there is availability.
                if (!selectionMatchedDate) {
                    this.preselectFirstDay();

                    this.isPreselectCompleted = true;

                    return;
                }

                this.calendarCollapsed = false;

                this.selectedDay = selectionMatchedDate;

                // Select the time if it is available.
                this.selectedDay.times.forEach((time: TimeBoard) => {
                    if (time.start_time.getTime() === selection.startTime.getTime() && time.isAvailable) {
                        this.selectedTime = time;
                    }
                });

                var firstAvailableTimeslot = selectionMatchedDate.times.find(timeSlot => timeSlot.isAvailable);

                // If the bookables don't match, the selected time was not available.
                if ((!this.selectedTime) || firstAvailableTimeslot.bookableId != this.selectedTime.bookableId) {
                    this.selectedTime = firstAvailableTimeslot;
                }

                this.isPreselectCompleted = true;

            } else {
                this.preselectFirstDay();

                this.isPreselectCompleted = true;
            }
        });

        if (this.selectedTime) {
            this.timeSelected(this.selectedTime, true);
        }
        else {
            this.noAvailability = true;
        }
    }

    /**
     * Find the first CalendarDay that has available time slots and select it.
     * @description Attempts to preselect the first day.
     */
    preselectFirstDay() {
        // Here we can use find() as it will return the first matched item.
        const firstAvailableDate = this.onlyCalendarDates().find(date => date.availableTimesCount > 0);

        // If nothing was found, then bail.
        if (!firstAvailableDate) {
            this.noAvailability = true;
            return;
        } else {
            this.noAvailability = false;
        }

        this.showTimes(firstAvailableDate);

        this.preselectFirstTimeSlot(firstAvailableDate);
    }

    /**
     * Given a CalendarDay, preselect the first available time slot.
     */
    preselectFirstTimeSlot(day: CalendarDay) {
        let found = false;
        day.times.forEach((time: TimeBoard) => {
            if (time.isAvailable === true && found === false) {
                this.selectedTime = day.times.find(timeSlot => timeSlot.isAvailable);
                found = true;
            }
        });
    }

    /**
     * Given a CalendarDay or MonthStartSignifier interface, return true if interface is of type MonthStartSignifier.
     */
    blockCanBeUsedForTitle(currentDate): boolean {
        return !currentDate.date && currentDate.month !== undefined;
    }

    /**
     * Given a CalendarDay, show its available times.
     * @description If the CalendarDay has no available times then we should end execution.
     */
    showTimes(selectedDay: CalendarDay) {

        if (selectedDay.availableTimesCount === 0) {
            return;
        }

        // Unselect any selected dates.
        this.clearAllDates();
        this.selectedDay = selectedDay;
    }s

    timeSelected(time: TimeBoard, preSelect: boolean = false) {
        // Ignore if the time slot is not available.
        if (!time.isAvailable) {
            return;
        }
        this.clearAllTimes();
        this.selectedTime = time;
        this.userSelectionsService.set('startTime', time.start_time);
        this.userSelectionsService.set('endTime', time.end_time);
        this.userSelectionsService.set('bookableId', time.bookableId);
        if(preSelect == false){
            this.analytics.formStarted();

        }
    }

    clearAllDates() {
        this.selectedDay = null;
    }

    clearAllTimes() {
        this.selectedTime = null;
    }

    /**
     * Return only CalendarDay(s) from this.dates.
     */
    onlyCalendarDates(): CalendarDay[] {
        return this.dates.filter(date => !this.blockCanBeUsedForTitle(date)) as CalendarDay[];
    }

    /**
     * Toggles the value of this.calendarCollapsed between true and false.
     */
    toggleCalendarCollapse() {
        this.calendarCollapsed = !this.calendarCollapsed;
    }

    preferencesUpdate(event) {
        this.userSelectionsService.set('modelPreferences', event);
    }

    private buildOldFormUrl(vehicle: Product) {
        return [
            this.appSettings.retailerBookingFormUrl,
            `?modelTreeReference=${encodeURIComponent(vehicle.modelTreeRef)}`,
            `&carName=${vehicle.combinedModelName}`
        ].join('');
    }

}
